import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {
    BsFileEarmarkTextFill,
    BsBriefcaseFill,
} from "react-icons/bs";
import "./collaborators.css";

import allPeople from "../../content/people/people.generated.json";

// Initials from a name, e.g. "Prof. Dr. Steffen Staab" -> "SS".
function initials(name) {
    const words = name
        .replace(/(Prof\.|Dr\.|rer\.|nat\.|PhD|M\.Sc\.|B\.Sc\.)/g, "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    if (words.length === 0) return "?";
    const first = words[0][0] || "";
    const last = words.length > 1 ? words[words.length - 1][0] || "" : "";
    return (first + last).toUpperCase();
}

// Icon per artifact type. "work" = a joint project in a company team.
function artifactIcon(type) {
    switch (type) {
        case "work": return <BsBriefcaseFill />;
        case "paper":
        default: return <BsFileEarmarkTextFill />;
    }
}

const Collaborators = ({ people }) => {

    const list = people || allPeople;

    return (
        <div className="collaborators">
            {
                list.map((p) => (
                    <div key={p.slug} className="collaborator">
                        <div className="collaborator-avatar">
                            {p.photo
                                ? <img src={p.photo} alt={p.name}></img>
                                : <span className="collaborator-initials">{initials(p.name)}</span>}
                        </div>

                        <div className="collaborator-name">
                            {p.link
                                ? <a href={p.link} target="_blank" rel="noreferrer">{p.name}</a>
                                : p.name}
                        </div>

                        {p.affiliation &&
                            <div className="collaborator-affiliation">{p.affiliation}</div>}

                        <div className="collaborator-work">
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>{p.work}</ReactMarkdown>
                        </div>

                        {p.artifacts.length > 0 &&
                            <div className="collaborator-artifacts">
                                {p.artifacts.map((a, i) => (
                                    <a
                                        key={i}
                                        className="collaborator-artifact"
                                        href={a.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        title={a.title || a.type}
                                        aria-label={a.title || a.type}
                                    >
                                        {artifactIcon(a.type)}
                                    </a>
                                ))}
                            </div>}
                    </div>
                ))
            }
        </div>
    );
};

export default Collaborators;
